export const SPARK_API = 'https://spark-api.owenhay.es/api'
